import { createApp } from 'vue'
import FormElementClassName from '@component_path/pages/m3c_premium_inquiries/series/haken_tap_form/className';
import MultiStepBox from '@component_path/pages/m3c_premium_inquiries/series/haken_tap_form';
import router from '@component_path/pages/m3c_premium_inquiries/series/haken_tap_form/routes/router';
import AgeParts from '@component_path/lib/ageParts';
import store from '@component_path/slide_form_common_module/store';
import MessageToSentry from '@component_path/lib/messageToSentry';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('multi-step-box-data');
  const props = JSON.parse(node.getAttribute('data'));
  props['master_data']['birth_years'] = AgeParts.createBirthYears();

  const app = createApp(MultiStepBox, props)
  app.use(router);
  app.config.errorHandler = MessageToSentry.fromVueInstance;

  router.isReady().then(() => {
    app.use(store).use(FormElementClassName).mount('#multi-step-box');
  });
});